define(['app', './template.html'], function (app, tmplInput) {
  return app.Marionette.ItemView.extend({
    template: tmplInput,

    ui: {
      wrapper: '.switch',
      toggle_btn: '.js-toggle'
    },

    events: {
      'click @ui.toggle_btn': 'toggleInput'
    },

    toggleButton: function (show) {
      this.ui.wrapper.toggleClass('on', show)
    },

    toggleInput: function (e) {
      e.preventDefault()

      var previousValue = this.original_input.prop('checked')
      this.original_input.prop('checked', !previousValue).change()

      return false
    },

    onRender: function () {
      this.toggleButton(this.original_input.prop('checked'))
    },

    initialize: function () {
      var self = this

      self.$el.after('<div class="switcher"></div>')

      self.original_input = this.$el

      self.original_input.hide().on('change', function () {
        self.toggleButton(self.original_input.prop('checked'))
      })

      self.setElement(this.$el.next('.switcher')[0])
    }
  })
})
